import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { TIER_COLORS } from '@backrs_ui/grow-ui/src/components/MyColleges/tierColors';
import type { CollegeTier } from '@backrs_ui/grow-ui/src/redux/userColleges/userColleges.types';

import { Box } from '@mui/material';

const STRINGS = appStrings.modules.myColleges;

export const tierLabel = (tier: CollegeTier | null) =>
  tier ? STRINGS.tierLabels[tier] : STRINGS.notRated;

type TierChipProps = Readonly<{ tier: CollegeTier | null; count: number }>;

export const TierChip = ({ tier, count }: TierChipProps) => {
  const colors = TIER_COLORS[tier ?? 'none'];

  return (
    <Box
      component="span"
      sx={({ backrs, typography }) => ({
        ...typography['text-sm-medium'],
        boxSizing: 'border-box',
        height: backrs.spacing['spacing-4xl'],
        paddingInlineEnd: backrs.spacing['spacing-xs'],
        paddingInlineStart: backrs.spacing['spacing-lg'],
        gap: backrs.spacing['spacing-lg'],
        borderRadius: backrs.radius['radius-full'],
        backgroundColor: backrs.colors[colors.bg],
        border: `1px solid ${backrs.colors[colors.border]}`,
        color: backrs.colors[colors.text],
        whiteSpace: 'nowrap',
        display: 'inline-flex',
        alignItems: 'center',
      })}
    >
      {tierLabel(tier)}
      <Box
        component="span"
        sx={({ backrs }) => ({
          boxSizing: 'border-box',
          display: 'inline-flex',
          alignItems: 'center',
          height: backrs.spacing['spacing-3xl'],
          paddingInline: backrs.spacing['spacing-md'],
          borderRadius: backrs.radius['radius-full'],
          border: `1px solid ${backrs.colors[colors.border]}`,
          backgroundColor: backrs.colors['Colors/Base/White'],
        })}
      >
        {count}
      </Box>
    </Box>
  );
};
